import styled from "@emotion/styled"
import { css } from "@emotion/react"

import { useConsole } from "contexts/Console"

import Link from "components/link/Link"

import getMediaQuery from "css/breakpoints"
import { fullGrid } from "css/grid"
import { headline70, surtitle70 } from "css/text"

const Root = styled.aside`
  ${fullGrid}
  text-align: center;
  justify-items: center;
  padding-block: 15vh;
  background: rgb(var(--pure-white));
`

const GlobalLink = styled(Link)`
  text-decoration: none;
  grid-column: col 1 / span 6;

  ${getMediaQuery("m")} {
    grid-column: col 4 / span 6;
  }

  * {
    pointer-events: none;
  }
`

const txtGradient = css`
  background: linear-gradient(45deg, rgb(var(--gradient-green-from)), rgb(var(--gradient-green-to)));
  background-clip: text;
  -webkit-text-fill-color: transparent;
`

const posInGrid = css`
  grid-column: col 1 / span 6;

  ${getMediaQuery("m")} {
    grid-column: col 4 / span 6;
  }
`

const Label = styled.p`
  ${surtitle70}
  display: block;
  ${posInGrid}
  ${txtGradient}
  margin-block-end: 10px;
`

const H2 = styled.h2`
  ${headline70}
  ${posInGrid}
  ${txtGradient}
  margin-block-end: 1.25rem;
  text-wrap: balance;
  &:lang(th) {
    padding-bottom: 0.6ex;
  }
`

export const StyledLink = styled(Link)`
  ${posInGrid}
  grid-row: 3;
`

export default function NextChapter({ label, jump_line, link, className, uid }) {
  const console = useConsole()

  console.verbose("NextChapter(%o)")
  return (
    <Root className={className}>
      <GlobalLink {...link} icon='none'>
        <Label>{label}</Label>
        <H2 id={uid} dangerouslySetInnerHTML={{ __html: jump_line }} />
        <StyledLink aria-describedby={uid} className='filled opaque-green' icon={link?.external ? "externalLink" : "none"}>
          {link?.label}
        </StyledLink>
      </GlobalLink>
    </Root>
  )
}
